export const isAnyCaseSilenced = ({ caseTracker = {} }) => {
  const keys = Object.keys(caseTracker);

  return (
    keys.length > 0 && keys.some((key) => caseTracker[key].silenced === true)
  );
};
